import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-selected",
  "use": "icon-selected-usage",
  "viewBox": "0 0 18 19",
  "content": "<symbol viewBox=\"0 0 18 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-selected\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.85456 11.8156L13.5231 5.81348L14.9771 7.18671L8.60208 13.9369L7.89555 14.685L7.16795 13.9574L3.04297 9.83238L4.45719 8.41817L7.85456 11.8156Z\" fill=\"#5587F0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol